export default __webpack_public_path__ + "static/media/IPad_4.1d3c1cc5.png";